var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.listSampleFees.length)?_c('div',{staticClass:"sampleFeesPage"},[_c('div',{staticClass:"tcAdmin_priceContent"},_vm._l((_vm.listSampleFees),function(item){return _c('SampleFeesPreviewForm',{key:item.id,attrs:{"dataList":item}})}),1)]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }